import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { withSagas } from 'decorators/Sagas';
import { decorateWith, withName } from 'helpers/decorator';
import { SignupCardCta } from './SignupCardCta';
import { PRODUCT_FORM, productFormAction, initializeProductForm, watchProductFormSagas } from '../sagas/product.saga';

export class ProductFormUnwrapped extends PureComponent {
  componentDidMount() {
    this.props.onMount(this.props.hiddenFields);
  }

  render() {
    const { copy, handleSubmit, submitting: isSubmitting, submitSucceeded: hasSucceeded } = this.props;

    return (
      <form id={PRODUCT_FORM} method="post" noValidate onSubmit={handleSubmit}>
        <SignupCardCta copy={copy} formId={PRODUCT_FORM} isSubmitting={isSubmitting} isDisabled={hasSucceeded} />
      </form>
    );
  }
}

ProductFormUnwrapped.propTypes = {
  copy: PropTypes.node,
  handleSubmit: PropTypes.func.isRequired,
  hiddenFields: PropTypes.object,
  onMount: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
  submitSucceeded: PropTypes.bool,
};

const formConfig = {
  enableReinitialize: true,
  form: PRODUCT_FORM,
  keepDirtyOnReinitialize: true,
  onSubmit: productFormAction,
  onSubmitSuccess: (result, dispatch, props) => props.onSuccess(result),
};

export const ProductForm = decorateWith(
  withSagas({ watch: watchProductFormSagas }),
  connect(
    null,
    { onMount: initializeProductForm }
  ),
  reduxForm(formConfig),
  withName('ProductForm')
)(ProductFormUnwrapped);
